import { Dispatch } from 'redux';
import { autofill } from 'redux-form';

import { FormsEnum } from 'app/shared/enums';
import { OfferFiltersInterface } from 'app/shared/interfaces/OfferFilters.interface';
import { dtoFieldToFormField } from './offerFiltersMapping';

export const hydrateOfferFilters = (
  offerFilters: OfferFiltersInterface | undefined,
  dispatch: Dispatch
) => {
  if (!offerFilters) {
    return;
  }

  (Object.keys(offerFilters) as (keyof OfferFiltersInterface)[]).forEach(
    (dtoField) => {
      const formField = dtoFieldToFormField[dtoField];
      const value = offerFilters[dtoField];

      if (formField && value !== undefined && value !== null) {
        dispatch(autofill(FormsEnum.OfferFilters, formField, value));
      }
    }
  );
};
